<template>
  <b-col cols="12">
    <b-card>
      <div slot="header">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <span
              v-html="`${$lang.profileLang.edit_term} <b>${termTitle}</b>`"
            />
            <h5>
              <b-badge
                v-if="termIsDeprecated"
                pill
                variant="danger"
                class="ml-2 mt-2 d-flex align-items-center"
              >
                <i class="fas fa-info-circle mr-1" />
                <span v-text="'این دوره غیرفعال می‌باشد'" />
              </b-badge>
            </h5>
          </div>
          <span v-text="`${$lang.profileLang.term_number}: ${termNumber}`" />
        </div>
      </div>

      <b-tabs>
        <b-tab :lazy="true" active>
          <template v-slot:title>{{ $lang.profileLang.term_info }}</template>
          <TermInfoTab
            @updateTermDate="updateTermDate"
            @updateItem="updateItem"
          />
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.term_select_items }}
          </template>
          <TermSelectItemsTab
            v-if="profileFields"
            :extraFields="profileFields"
          />
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.profileLang.term_statues }}
          </template>
          <TermStatusTab />
        </b-tab>
        <b-tab :lazy="true">
          <template v-slot:title>
            {{ $lang.attachments }}
          </template>
          <TermAttachmentsTab :parentItems="attachmentFields" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-col>
</template>

<script>
import TermInfoTab from "./edit-term-tabs/termInfoTab.vue";
import TermStatusTab from "./edit-term-tabs/termStatusTab.vue";
import TermSelectItemsTab from "./edit-term-tabs/termSelectItemsTab.vue";
import TermAttachmentsTab from "./edit-term-tabs/termAttachmentsTab.vue";
import { pathOr } from "ramda";

export default {
  components: {
    TermInfoTab,
    TermStatusTab,
    TermSelectItemsTab,
    TermAttachmentsTab,
  },
  data() {
    return {
      item: null,
      termIsDeprecated: false,
    };
  },
  computed: {
    termTitle() {
      return pathOr("", ["caption"], this.item);
    },
    termNumber() {
      return pathOr("", ["id"], this.item);
    },
    profileFields() {
      return pathOr(null, ["extra_fields", "profile"], this.item);
    },
    attachmentFields() {
      return pathOr([], ["extra_fields", "attachment"], this.item);
    },
  },
  methods: {
    pathOr,
    updateItem(data) {
      this.item = data;
    },
    updateTermDate(data) {
      this.termIsDeprecated = data;
    },
  },
};
</script>
